// src/types/User.ts
import { AxiosResponse } from "axios";
import httpClient, { apiRoutePrefix } from "../httpClient/httpClient";

export const HelenService = {
  async getHelenBotsForUser(loginemail: any): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/getHelenBotsForUser`,
      { login_email: loginemail }
    );
    return res;
  },
  async getBotsAssignedToUser(Status: string = "all"): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/getBotsAssignedToUser`,
      {
        status: Status,
      }
    );
    return res;
  },

  async getNonAssignedBots(): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/getNonAssignedBots`
    );
    return res;
  },
  async assignBotToTeamMember(
    userId: any,
    selectedMemberUserId: any,
    selectedHelenId: any
  ): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/assignBotToTeamMember`,
      {
        admin_user_id: userId,
        team_member_user_id: selectedMemberUserId,
        helen_id_to_assign: selectedHelenId,
      }
    );
    return res;
  },
  async createSubscription(
    userId: any,
    planId: any,
    helenBots?: any
  ): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/createSubscription`,
      {
        userId,
        planId,
        helenBots, // number of bots selected
      }
    );
    return res;
  },
  async getSubscription(session_id: any): Promise<AxiosResponse> {
    const res = await httpClient.get<AxiosResponse>(
      `${apiRoutePrefix}/getSubscriptionDetails?session_id=${session_id}`
    );
    return res;
  },
  // Add more auth-related calls as needed
};
